import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { orgapi } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchMsgDataSuccess = (chatdata: any) => ({
    type: 'FETCH_DATA_SUCCESS_MAS',
    payload: chatdata,
});

//To get list of officers data
export const fetchData = (uid:any,usertype:any,donationID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { Userid:uid,usertype:usertype,need:donationID };
            const apiname = orgapi.orgdchat;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const sendmsgdata = (uid:any,message:any,donationID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { Userid:uid,message:message,need:donationID};
            const apiname = orgapi.orgdmsg;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchMsgDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};